/**
 * TEMPORARY: a log of wheel scrolling, for reports that cannot be reproduced
 * from a test — a free-spinning wheel, macOS momentum. Off unless this
 * browser has `localStorage.debugWheel = '1'`; then it prints one line per
 * scroll to the console (a pause of 500ms ends one, as it does for Chrome):
 * where it began, which of its events could be cancelled (C) or not (n) and
 * how many were, and what each scrolled.
 *
 * Remove once the scrolling around open cards is settled.
 */

/** where an element is, in the words of the reports */
const where = (el: Element | null): string => {
    if (!el?.closest) return 'outside';
    if (el.closest('[data-open-row]')) return el.closest('[data-contain-scroll], .nx-open-row__panel') ? 'card body' : 'card';
    return el.closest('.layout-v2-content') ? 'list' : 'outside';
};

type Scroll = {
    began: string;
    events: number;
    cancelable: string;
    cancelled: number;
    deltaY: number;
    mode: number;
    scrolled: Record<string, number>;
};

const startWheelDebug = (): (() => void) => {
    let on = false;
    try {
        on = window.localStorage.getItem('debugWheel') === '1';
    } catch {
        // storage blocked: stay off
    }
    if (!on) return () => undefined;

    let scroll: Scroll | null = null;
    let timer: number | undefined;
    const flush = () => {
        // eslint-disable-next-line no-console
        if (scroll) console.info('[wheel]', JSON.stringify(scroll));
        scroll = null;
    };

    const onWheel = (event: WheelEvent) => {
        if (!scroll) {
            scroll = { began: where(event.target as Element), events: 0, cancelable: '', cancelled: 0, deltaY: 0, mode: event.deltaMode, scrolled: {} };
        }
        const current = scroll;
        current.events += 1;
        current.deltaY += event.deltaY;
        if (current.cancelable.length < 80) current.cancelable += event.cancelable ? 'C' : 'n';
        // read once every listener has had it
        window.setTimeout(() => { if (event.defaultPrevented) current.cancelled += 1; });
        window.clearTimeout(timer);
        timer = window.setTimeout(flush, 500);
    };
    const onScroll = (event: Event) => {
        if (!scroll) return;
        const target = event.target as Element | Document;
        const name = target instanceof Element ? where(target) : 'document';
        scroll.scrolled[name] = (scroll.scrolled[name] || 0) + 1;
    };

    window.addEventListener('wheel', onWheel, { capture: true, passive: true });
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    return () => {
        window.removeEventListener('wheel', onWheel, { capture: true });
        document.removeEventListener('scroll', onScroll, { capture: true });
        window.clearTimeout(timer);
    };
};

export default startWheelDebug;
